<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <!-- 2025 © Royal City Fabrics -->
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          <p class="small mb-0">© 2025 M.Siddquie Steel. <br> Powered by <a href="https://brainexworld.com/"
              target="_blank"><strong>Brainex
                World Pvt. Ltd</strong></a></p>
        </div>
      </div>
    </div>
  </div>
</footer>